<nz-modal
  [nzVisible]="isVisible()"
  [nzFooter]="null"
  nzWrapClassName="role-selection__wrapper"
  nzClassName="role-selection__container"
  nzNoAnimation
  [nzCentered]="true"
  [nzCloseOnNavigation]="false"
  [nzDraggable]="false"
  nzWidth="1280px"
  [nzStyle]="{
    top: '0px',
    margin: '0px',
    padding: '0px',
    'max-width': '1280px'
  }"
  [nzBodyStyle]="{ padding: '0px', height: '800px', width: '1280px' }">
  <ng-container *nzModalContent>
    <div
      class="role-selection__content"
      [attr.data-cy]="'no-role-selected-popup'">
      <div class="role-selection__left">
        <div class="role-selection__logo">
          <img
            #imageToRefetch
            class="logo"
            src="assets/images/AiOmed_logo_small.svg"
            alt="AiOmed_logo" />
        </div>
        <aiomed-login-no-role
          [isMatrixCare]="isMatrixCare()"
          [hasYesDisabled]="hasYesDisabled()"
          (noClicked)="noClicked.emit()"
          (yesClicked)="yesClicked.emit()" />
      </div>
      <div class="role-selection__right">
        <h3 class="role-selection__right--title">Hi, Welcome</h3>
        <p class="role-selection__right--description">Please log in</p>
        <img
          #imageToRefetch
          class="role-selection__right--image"
          [src]="'assets/images/' + 'pcc-login-required.svg'"
          priority="true"
          [width]="325"
          [height]="305"
          alt="login-lock" />
      </div>
    </div>
  </ng-container>
</nz-modal>
